import { render, staticRenderFns } from "./PersonnelRecordsDataTable.vue?vue&type=template&id=5898b68e&scoped=true"
import script from "./PersonnelRecordsDataTable.vue?vue&type=script&lang=js"
export * from "./PersonnelRecordsDataTable.vue?vue&type=script&lang=js"
import style0 from "./PersonnelRecordsDataTable.vue?vue&type=style&index=0&id=5898b68e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5898b68e",
  null
  
)

export default component.exports